import React, { Fragment, useMemo } from 'react';
import { IntlProvider, injectIntl } from 'react-intl';
import { intlShape } from 'modules/utils';

// This HOC component should be used only in the components defined in the modules folder.
// This is done because the injectIntl HOC is been used and that component expect to receive a context defined by
// the InltProvider declared at the top level of the application
const withIntlProvider = (locales = {}) => Component => {
	const IntlComponent = ({ intl, ...props }) => {
		const { locale, messages: commonMessages } = intl;
		const messages = { ...commonMessages, ...locales[locale] };
		const InjectedComponent = useMemo(() => injectIntl(Component), []);
		return (
			<IntlProvider
				messages={messages}
				textComponent={Fragment}
				locale={locale}
			>
				<InjectedComponent {...props} />
			</IntlProvider>
		);
	};

	IntlComponent.propTypes = {
		intl: intlShape,
	};

	IntlComponent.displayName = `IntlComponent(${Component.displayName ||
		Component.name ||
		'Component'})`;

	return injectIntl(IntlComponent);
};

export default withIntlProvider;
